import React, { useEffect, useRef, useState } from 'react';
import { LOCALSTORAGE_KEY } from '@/constants/calendar';
import { isMobile } from 'react-device-detect';
import useObserver from '@/hooks/page/useObserver';
import { Icon } from '@iconify/react';

const LOOKING_FOR_DROPDOWN = [
  'For information about SpaceMap',
  'To work with SpaceMap',
  'To invest in SpaceMap',
  'To connect with SpaceMap about another topic',
];

const MobileContact = () => {
  const contactRef = useRef(null);
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [lookingForIndex, setLookingForIndex] = useState(0);

  const checkKey = e => {
    if (
      e.key === 'PageUp' ||
      e.key === 'ArrowUp' ||
      e.key === 'PageDown' ||
      e.key === 'ArrowDown'
    )
      e.stopPropagation();
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const response = await fetch(process.env.REACT_APP_EMAIL_ENDPOINT, {
      method: 'POST',
      body: JSON.stringify({
        email,
        name,
        message,
        lookingFor: LOOKING_FOR_DROPDOWN[lookingForIndex],
      }),
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'no-cors',
    });

    if (response) {
      alert('Email sent successfully. We will get back to you shortly.');
      resetForm();
    } else {
      alert('Email failed to send. Please try again later.');
    }
  };

  const resetForm = () => {
    setEmail('');
    setName('');
    setMessage('');
    setLookingForIndex(0);
  };

  useObserver('content-Contact');

  useEffect(() => {
    if (isMobile && localStorage.getItem(LOCALSTORAGE_KEY)) {
      contactRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      localStorage.removeItem(LOCALSTORAGE_KEY);
    }
  }, []);

  return (
    <div className='min-h-screen'>
      <div className='flex h-full w-full items-center p-[20px] gap-[8px]'>
        <p className='flex-1 text-center font-semibold text-black text-sm'>
          Contact Us
        </p>
      </div>

      <div className='flex flex-col w-full h-full px-[20px] gap-[32px]'>
        <div className='flex flex-col gap-[16px]'>
          <div className='flex flex-col gap-[6px]'>
            <label className='text-[16px] font-medium text-[#A7A7A7]'>
              Name
            </label>
            <input
              type='text'
              name='name'
              required
              value={name}
              onChange={e => setName(e.target.value)}
              onKeyDown={e => checkKey(e)}
              className='h-[56px] w-full text-[16px] px-[16px] py-[8px] border border-[#4B4B4B] rounded-[6px]'
            />
          </div>

          <div className='flex flex-col gap-[6px]'>
            <label className='text-[16px] font-medium text-[#A7A7A7]'>
              Email
            </label>
            <input
              type='email'
              name='email'
              required
              value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => checkKey(e)}
              className='h-[56px] w-full text-[16px] px-[16px] py-[8px] border border-[#4B4B4B] rounded-[6px]'
            />
          </div>

          <div className='flex flex-col gap-[6px]'>
            <label className='text-[16px] font-medium text-[#A7A7A7]'>
              Looking for
            </label>
            <div className='relative'>
              <select
                className='h-[56px] w-full px-[16px] py-[8px] border border-[#4B4B4B] rounded-[6px] appearance-none pr-[48px]'
                value={LOOKING_FOR_DROPDOWN[lookingForIndex]}
                onChange={e => {
                  const index = LOOKING_FOR_DROPDOWN.indexOf(e.target.value);
                  setLookingForIndex(index);
                }}
              >
                {LOOKING_FOR_DROPDOWN.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </select>
              <Icon
                icon='fe:arrow-down'
                className='absolute right-[16px] top-1/2 transform -translate-y-1/2 pointer-events-none text-[#949494]'
                width={16}
                height={16}
              />
            </div>
          </div>

          <div className='flex flex-col gap-[6px]'>
            <label className='text-[16px] font-medium text-[#A7A7A7]'>
              Message
            </label>
            <textarea
              name='message'
              value={message}
              onChange={e => setMessage(e.target.value)}
              onKeyDown={e => checkKey(e)}
              rows={1}
              className='min-h-[56px] w-full text-[16px] px-[16px] py-[8px] border border-[#4B4B4B] rounded-[6px]'
            />
          </div>
        </div>
      </div>

      <div className='flex justify-center p-[20px] gap-[8px]'>
        <button
          onClick={handleSubmit}
          className='w-full align-center rounded-[6px] justify-center h-[56px] p-[16px] gap-[8px] bg-[#FCCB16] text-black text-[16px] font-[600]'
        >
          Send
        </button>
      </div>
    </div>
  );
};

export default React.memo(MobileContact);
